<template>
  <div>
    <card-toolbar
      :title="$tc('not_authorized')"
    />

    <v-row class="pa-4">
      <h1>{{ $tc('not_authorized') }}</h1>
    </v-row>
  </div>
</template>

<script>
import CardToolbar from '@/components/CardToolbar'
export default {
  components: { CardToolbar }
}
</script>
